var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContentLayoutOnly',{attrs:{"role":"region","twofactorsetup":""}},[_c('section',{staticClass:"section card"},[_c('div',{staticClass:"level pl-5 pr-5"},[_c('TwoFactorSetup')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }